import appLaunch from './appLaunch';

const watchers = [appLaunch];

export default watchers;
